module.exports = __webpack_public_path__ + "static/acton_hero-525b591410ccd7c0c3889b79761015b6.png";